module.exports = __webpack_public_path__ + "img/teamImg1.6ce8279d.jpg";